// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.

import {
  LOCAL_STORAGE_CALL_ID_HISTORY_KEY,
  getJsonFromLocalStorage,
  removeFromLocalStorage,
  saveJsonToLocalStorage
} from './localStorage';

export const NUMBER_OF_CALL_IDS_TO_STORE = 10;

export type CallIdHistory = {
  callId: string;
  date: string; // ISO string
}[];

export const saveLatestCallIdToLocalStorage = (callId: string): void => {
  const callIdHistory = getJsonFromLocalStorage<CallIdHistory>(LOCAL_STORAGE_CALL_ID_HISTORY_KEY) ?? [];
  callIdHistory.unshift({ callId, date: new Date().toISOString() });
  saveJsonToLocalStorage(LOCAL_STORAGE_CALL_ID_HISTORY_KEY, callIdHistory.slice(0, NUMBER_OF_CALL_IDS_TO_STORE));
};

export const getCallIdHistoryFromLocalStorage = (): CallIdHistory => {
  return getJsonFromLocalStorage<CallIdHistory>(LOCAL_STORAGE_CALL_ID_HISTORY_KEY) ?? [];
};

export const clearCallIdHistory = (): void => {
  return removeFromLocalStorage(LOCAL_STORAGE_CALL_ID_HISTORY_KEY);
};
